import { memo } from "react";
import { BaseEdge, EdgeLabelRenderer, getSmoothStepPath } from "@xyflow/react";
import { X } from "lucide-react";

const SELECTED_EDGE_STROKE = "#0F6E56";
const EDGE_INTERACTION_WIDTH = 24;

function WorkflowDeletableEdge({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    style = {},
    markerEnd,
    selected,
    data,
}) {
    const [edgePath, labelX, labelY] = getSmoothStepPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
    });

    const edgeStyle = selected
        ? {
            ...style,
            stroke: SELECTED_EDGE_STROKE,
            strokeDasharray: "6 4",
            strokeWidth: 2.5,
        }
        : style;

    const handleDelete = (event) => {
        event.stopPropagation();
        data?.onDelete?.();
    };

    return (
        <>
            <BaseEdge
                id={id}
                path={edgePath}
                markerEnd={markerEnd}
                style={edgeStyle}
                interactionWidth={EDGE_INTERACTION_WIDTH}
            />
            {selected && (
                <EdgeLabelRenderer>
                    <div
                        className="nodrag nopan pointer-events-auto"
                        style={{
                            position: "absolute",
                            transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
                        }}
                    >
                        <button
                            type="button"
                            aria-label="Remove connection"
                            onClick={handleDelete}
                            className="flex h-6 w-6 items-center justify-center rounded-full border border-red-500 bg-white shadow-sm transition-colors hover:bg-red-50 dark:border-red-400 dark:bg-slate-900 dark:hover:bg-red-950/40"
                        >
                            <X className="h-3.5 w-3.5 text-red-500 dark:text-red-400" strokeWidth={2.5} />
                        </button>
                    </div>
                </EdgeLabelRenderer>
            )}
        </>
    );
}

export default memo(WorkflowDeletableEdge);
